<div class="overlay" (click)="close()"></div>

<div class="modal">
    <div class="modal-header">
        <button class="close-btn" (click)="close()">✕</button>
    </div>

    <div class="modal-body form-success" *ngIf="formSuccess">
        <div class="success-icon">✓</div>
        <h3>{{ 'partnerFormModal.success.title' | translate }}</h3>
        <p>{{ 'partnerFormModal.success.body' | translate }}</p>
        <button class="btn-primary" (click)="formSuccess = false">{{ 'partnerFormModal.success.submitAnother' | translate }}</button>
    </div>

    <form [formGroup]="partnerForm" (ngSubmit)="onSubmit()" *ngIf="!formSuccess">
        <div class="modal-body">
            <div class="form-group">
                <label class="form-label">{{ 'partnerFormModal.fields.fullName' | translate }} <span class="required-mark">*</span></label>
                <input type="text" class="form-control" [class.is-invalid]="isFieldInvalid('fullName')"
                    formControlName="fullName" [placeholder]="'partnerFormModal.fields.fullNamePlaceholder' | translate" />
                <div class="form-error" *ngIf="isFieldInvalid('fullName')">{{ 'partnerFormModal.fields.fullNameError' | translate }}</div>
            </div>

            <div class="form-group">
                <label class="form-label">{{ 'partnerFormModal.fields.email' | translate }} <span class="required-mark">*</span></label>
                <input type="email" class="form-control" [class.is-invalid]="isFieldInvalid('email')"
                    formControlName="email" [placeholder]="'partnerFormModal.fields.emailPlaceholder' | translate" />
                <div class="form-error" *ngIf="isFieldInvalid('email')">{{ 'partnerFormModal.fields.emailError' | translate }}</div>
            </div>

            <div class="form-group">
                <label class="form-label">{{ 'partnerFormModal.fields.organization' | translate }} <span class="required-mark">*</span></label>
                <input type="text" class="form-control" [class.is-invalid]="isFieldInvalid('organization')"
                    formControlName="organization" [placeholder]="'partnerFormModal.fields.organizationPlaceholder' | translate" />
                <div class="form-error" *ngIf="isFieldInvalid('organization')">{{ 'partnerFormModal.fields.organizationError' | translate }}</div>
            </div>

            <div class="form-group">
                <label class="form-label">{{ 'partnerFormModal.fields.partnerType' | translate }} <span class="required-mark">*</span></label>
                <div class="select-wrapper">
                    <select class="form-control form-select" [class.is-invalid]="isFieldInvalid('partnerType')"
                        formControlName="partnerType">
                        <option value="" disabled selected>{{ 'partnerFormModal.fields.partnerTypePlaceholder' | translate }}</option>
                        <option *ngFor="let opt of partnerTypeOptions" [value]="opt.value">{{ opt.labelKey | translate }}</option>
                    </select>
                </div>
                <div class="form-error" *ngIf="isFieldInvalid('partnerType')">{{ 'partnerFormModal.fields.partnerTypeError' | translate }}</div>
            </div>

            <div class="form-group">
                <label class="form-label">{{ 'partnerFormModal.fields.interest' | translate }}</label>
                <textarea class="form-control form-textarea" formControlName="interest"
                    [placeholder]="'partnerFormModal.fields.interestPlaceholder' | translate" rows="4"></textarea>
            </div>
        </div>

        <div class="modal-footer">
            <button type="submit" class="btn-submit" [disabled]="formSubmitting">
                <span *ngIf="!formSubmitting">{{ 'partnerFormModal.btns.submit' | translate }}</span>
                <span *ngIf="formSubmitting">{{ 'partnerFormModal.btns.submitting' | translate }}</span>
            </button>
        </div>
    </form>
</div>
